//消息类型定义
export const MessageType = {
    S_SEQ_UPDATE: "S_SEQ_UPDATE",
    S_GPS: "S_GPS",
    S_UPLOAD_LOG: "S_UPLOAD_LOG",
    S_CUSTOM: "S_CUSTOM",
    S_SWITCH_LOG: "S_SWITCH_LOG",
    S_CRITICAL_LOG: "S_CRITICAL_LOG",
};

